import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';
import Form from '.';

export interface INewsletterCtaProps extends IBaseElementProps {
	image?: IImage;
	subheading?: string;
	heading?: string;
	text?: string;
}

/**
 * Newsletter Cta
 * @block
 * @requiresHooks
 * @icon feedback
 */
const NewsletterCta: React.FC<INewsletterCtaProps> = ({
	className,
	classNames = [],
	image,
	subheading,
	heading,
	text,
	children,
}) => (
	<div className={className || cn('newsletter-cta', ...classNames)}>
		<div className="newsletter-cta__image">
			{image && <Image {...image} />}
		</div>
		<div className="newsletter-cta__form">
			{subheading && <h2 className="newsletter-cta__subheading">{subheading}</h2>}
			{heading && <h2 className="newsletter-cta__heading">{heading}</h2>}
			{text && <div className="newsletter-cta__text">{text}</div>}
			<Form>{children}</Form>
		</div>
	</div>
);

export default NewsletterCta;
